(function () {
  'use strict';
  /* Verzendbescherming in de cart drawer (27-10-2026). Markup: snippets/snr-verzendbescherming.liquid.
     - klant zet hem aan/uit met de schakelaar
     - staat er alleen nog bescherming in de cart, dan gaat die er automatisch uit
     - data-auto="true" voegt hem automatisch toe, tenzij de klant hem zelf heeft uitgezet (localStorage snr_prot_off) */
  var OFF_KEY = 'snr_prot_off';
  var busy = false;

  function isOff() { try { return localStorage.getItem(OFF_KEY) === '1'; } catch (e) { return false; } }
  function setOff(v) { try { if (v) localStorage.setItem(OFF_KEY, '1'); else localStorage.removeItem(OFF_KEY); } catch (e) {} }

  function sectionIds() {
    var d = document.querySelector('sht-cart-drwr');
    try { return (d && typeof d.getSectionsToRender === 'function') ? d.getSectionsToRender().map(function (s) { return s.section; }) : []; } catch (e) { return []; }
  }

  function updateCounts(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (it.handle !== 'verzendbescherming') n += it.quantity; });
    document.querySelectorAll('.header__cart-count .cart-count-number, .js-cart-count').forEach(function (el) { el.textContent = n; });
  }

  function setQty(vid, qty, byUser) {
    var updates = {}; updates[vid] = qty;
    var body = { updates: updates };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids; body.sections_url = location.pathname; }
    busy = true;
    var el = document.querySelector('.snr-prot');
    if (el) el.classList.add('is-busy');
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart || cart.status) throw cart;
      busy = false;
      var f = document.querySelector('sht-cart-drwr-frm');
      if (cart.sections && f && typeof f.renderContents === 'function') { f.renderContents(cart); updateCounts(cart); }
      else if (byUser) { location.reload(); }
    })
    .catch(function () {
      busy = false;
      if (byUser) { location.reload(); return; }
      var e = document.querySelector('.snr-prot'); if (e) e.classList.remove('is-busy');
    });
  }

  window.snrProtToggle = function (btn) {
    if (busy) return;
    var el = btn.closest('.snr-prot');
    if (!el) return;
    var on = el.classList.contains('is-on');
    setOff(on);
    el.classList.toggle('is-on', !on);
    btn.setAttribute('aria-checked', String(!on));
    setQty(el.dataset.vid, on ? 0 : 1, true);
  };

  function sync() {
    if (busy) return;
    var el = document.querySelector('.snr-prot');
    if (!el) return;
    var items = parseInt(el.dataset.items, 10) || 0;
    var qty = parseInt(el.dataset.qty, 10) || 0;
    var vid = el.dataset.vid;
    if (qty > 0 && items === 0) { setQty(vid, 0, false); return; }
    if (qty > 1) { setQty(vid, 1, false); return; }
    if (el.dataset.auto === 'true' && items > 0 && qty === 0 && !isOff()) { setQty(vid, 1, false); }
  }

  var t;
  function watch() {
    sync();
    var d = document.querySelector('sht-cart-drwr');
    if (!d) return;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 150); }).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
